import { Badge } from "@xola/ui-kit";
import { isExperiencePurchaseItem, PurchaseItemStatus } from "common";
import React from "react";
import { Purchase, PurchaseItem } from "types";
import { isDisputeSubmitted } from "../../../models/Purchase";
import { disputeBadgeInfo } from "../PurchaseDisputeBadge";
import { StatusInfo, statusMap } from "../PurchaseStatusIcon";

interface PurchaseInfoProps {
    purchase: Purchase;
    item?: PurchaseItem; // Optional because MIST won't have an item
}

export const PurchaseInfoBadge = ({ purchase, item: selectedItem }: PurchaseInfoProps) => {
    const isPackage = !!purchase.items[0].parentProduct?.id && !selectedItem;
    const item = selectedItem ?? purchase.items[0];
    const isMist = purchase.items.length > 1 && !isPackage && !selectedItem;
    if (!isExperiencePurchaseItem(item)) {
        return null;
    }

    let info: StatusInfo | null = isDisputeSubmitted(purchase) ? disputeBadgeInfo : statusMap[item.status];
    if (isPackage) {
        const confirmedItem = purchase.items.find((item) => item.status === PurchaseItemStatus.CONFIRMED);
        if (confirmedItem) {
            info = statusMap[confirmedItem.status];
        }
    }

    const allCanceled = purchase.items.every((item) => item.status === PurchaseItemStatus.CANCELED);
    if (isPackage && item.status === PurchaseItemStatus.CANCELED && !allCanceled) {
        info = null; // only a "PACKAGE" with all cancelled items should be considered canceled
    }

    return info && !isMist ? (
        <Badge
            color={info.color ?? "secondary"}
            size="medium"
            icon={info.icon}
            data-testid="purchase-customer-information-item-status"
        >
            {info.title}
        </Badge>
    ) : null;
};
